import './style.less'
import ExternalModalCtrl from '../../modals/external/ctrl'
import SolutionModalCtrl from '../solution/ctrl'

export default class ProductModalCtrl {
  constructor(close, $scope, id, products, $rootScope, ModalService, $sce) {
    this.close = close
    this.product = products.find((el) => { return el.id == id })
    this.ModalService = ModalService
    this.$rootScope = $rootScope

    this.carouselIndex = 0

    this.productSolutions = $rootScope.solutions.filter((el) => {
      return (this.product.solutions.includes(el.id))
    })

    $scope.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    }

    $scope.trustHtml = function (html) {
      return $sce.trustAsHtml(html);
    }

  }

  close() {
    this.close()
  }

  openExternal(item) {
    if (item.blank) {
      window.open(item.url, '_blank')
    } else {
      this.ModalService.showModal({
        template: require('../external/view.html'),
        controller: ExternalModalCtrl,
        controllerAs: 'modal',
        inputs: {
          link: item.url
        },
        appendElement: angular.element(document.querySelector('#app-wrapper'))
      })
    }

  }

  openSolution(id) {
    this.$rootScope.$broadcast('close')
    this.close()

    for (let el of this.$rootScope.categories) {
      el.selected = false
    }

    this.$rootScope.$emit('categoryClear')

    this.ModalService.showModal({
      template: require('../solution/solution.html'),
      controller: SolutionModalCtrl,
      controllerAs: 'modal',
      inputs: {
        id: id,
        selected: false
      },
      appendElement: angular.element(document.querySelector('#app-wrapper'))
    })
  }

  next() {
    if (this.carouselIndex == (this.product.subpages.length - 1)) {
      this.carouselIndex = 0
      return
    }
    this.carouselIndex += 1
  }

  prev() {
    if (this.carouselIndex == 0) {
      this.carouselIndex = this.product.subpages.length
      return
    }
    this.carouselIndex -= 1
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/product/ctrl.js